import { openPopupWidget } from "react-calendly";

const openCalendlyPopup = () => {
  openPopupWidget({ 
    url: 'https://calendly.com/haashir/chat?hide_event_type_details=1&hide_gdpr_banner=1',
  });
}

export default openCalendlyPopup;